<template>
    <div style="height: 70vh" class="w-full flex flex-col items-center justify-center" >
        
        <h1 style="font-family: 'courier New'; font-weight: bold" class="text-4xl md:text-6xl ">
            <span class="whitespace-nowrap">
                Ear-training
            </span>
             Workshop
        </h1>

        <!-- <h3 class="w-2/5  self-end" >

            Reza Seyedi
        </h3> -->
        <!-- <OtherComps /> -->
    </div>

</template>

<style scoped>
h1, h3 {
    font-family: 'Courier New', Courier, monospace;
    font-weight: bold;
    
}

h3 {
    font-size: 40px
}
</style>